import React, { MouseEventHandler } from "react"
import './ContextMenu.css'
import { Action, ActionMenu } from "actions/Action";


export interface ContextMenuProps {
    children: React.ReactNode;
    menu: () => Array<Action>;
}

export interface ContextMenuState {
    top: number;
    left: number;
    visible: boolean;
}


/* Wrap your components with me to get context menus.

This is just a simple text-only context menu for now. Icons and fancy layouts can come later.

TODO: actions. 
*/
export class ContextMenu extends React.Component<ContextMenuProps, ContextMenuState>  {
    constructor(props: Readonly<ContextMenuProps>) {
        super(props);
        this.state = {
            visible: false,
            top: 0,
            left: 0
        }
    }

    render = () => {
        let children = this.state.visible
            ? this.props.children
            : this.renderChildren();

        return <>
            {children}
            {this.state.visible &&
                <div className={'contextMenuRestOfPage'}
                    onClick={(ev) => this.setState({ visible: false })}>
                </div>
            }
           
                <ContextMenuRender
                    menu={this.props.menu}
                    top={this.state.top}
                    left={this.state.left}
                    visible={this.state.visible}
                ></ContextMenuRender>

        </>
    }

    renderChildren = () => {
        return <span onContextMenu={this.onContextMenu}>
            {this.props.children}
        </span>
    }

    onContextMenu: MouseEventHandler<HTMLElement> = (ev) => {
        ev.preventDefault(); // Prevent the browser context menu.
        
        let v = ev.currentTarget.getBoundingClientRect();

        // Make this menu appear under the selected element.
        this.setState({
            top: v.top + v.height, // ev.pageY,
            left: v.left, // ev.pageX,
            visible: true
        });
    }
}

export class Menu extends ContextMenu {
    override renderChildren = () => {
        return <span onClick={this.onClick} onContextMenu={this.onContextMenu}>
            {this.props.children}
        </span>
    }

    onClick: MouseEventHandler<HTMLElement> = (ev) => {
        this.onContextMenu(ev);
    };
}

export interface ContextMenuRenderProps {
    target?: any, // Not used?
    menu: () => Array<Action>;
    top: number;
    left: number;
    visible: boolean;
}

export interface ContextMenuRenderState {
    submenu?: ContextMenuRenderProps;
}

/* I exist because of a stupidity in CSS: if you use translateX(), then you can't use position:fixed. Thus, the
DataTable needs to have the context menu outside the translated divs, but the event handler remains inside them. 
Thus, DataTable manually handles a lot of the stuff that ContextMenu above handles.
/forehead_slap.
*/
export class ContextMenuRender extends React.Component<ContextMenuRenderProps, ContextMenuRenderState>  {
    private menuRef: React.RefObject<HTMLDivElement>;

    constructor(props: Readonly<ContextMenuRenderProps>) {
        super(props);
        this.state = {
        }
        this.menuRef = React.createRef();
    }

    componentDidUpdate = (prevProps: ContextMenuRenderProps, prevState: ContextMenuRenderState) => {
        if (!this.props.visible && prevProps.visible) {
            this.setState({ submenu: undefined });
        }
    }

    /* Ensure that the menu stays within the viewport. */
    getPosition = (left:number, top:number) => {
        let resultLeft : number;
        let resultTop : number;

        // I want to render so I know my size via this.menuRef.
        if (!this.props.visible) {
            return [-9999, 0];
        }

        let menuWidth = this.menuRef.current?.offsetWidth;
        let menuHeight = this.menuRef.current?.offsetHeight;

        if (!window.visualViewport) return [0,0];
        if (!menuWidth) return [0,0];
        if (!menuHeight) return [0,0];

        if (left > window.visualViewport.width - menuWidth) {
            resultLeft = window.visualViewport.width - menuWidth - 4;            
        } else {
            resultLeft = left;
        }

        if (top > window.visualViewport.height - menuHeight) {
            resultTop = window.visualViewport.height - menuHeight - 4;
        } else {
            resultTop = top;
        }

        return [resultLeft, resultTop];

    }

    render = () => {
        let submenu = this.state.submenu;

        let left, top : number;
        [left, top] = this.getPosition(this.props.left, this.props.top);

        // TODO: I'm still in the tab order if I'm not visible.

        if (!this.props.menu) {
            console.warn("Empty menu");
            return <></>; 
        }

        return <div ref={this.menuRef} className={'menu'}
            style={{ position: 'fixed', top: top, left: left }}>
            <ul style={{ listStyleType: 'none', paddingInlineStart: 0, margin: 0 }}>

                {this.props.menu().map(each => {
                    if (!((each as any).menu)) {
                        // It's a vanilla action
                        return <li
                            className={"menuItem"}
                            onClick={(ev) => {
                                ev.preventDefault();
                                each.do();
                            }}
                            onMouseOver={(ev) => this.setState({ submenu: undefined })}
                            key={each.label}>
                            {each.label}
                        </li>
                    } else {
                        // It's a menu.
                        return <li
                            className={"menuItem"}
                            onMouseOver={(ev: React.MouseEvent<HTMLLIElement>) => {
                                ev.preventDefault();
                                let coords = ev.currentTarget.getBoundingClientRect();
                                let submenu: ContextMenuRenderProps = {
                                    menu: () => (each as ActionMenu).menu,
                                    left: coords.x + 50,
                                    top: coords.y,
                                    visible: true
                                };
                                this.setState({
                                    submenu: submenu
                                });
                            }}
                            key={each.label}>
                            {each.label}
                        </li>
                    }
                })
                }
            </ul>
            {submenu &&
                <ContextMenuRender target={submenu.target} menu={submenu.menu} left={submenu.left} top={submenu.top} visible={submenu.visible} />
            }
        </div>

    }
}